export const capitalize = (phrase) => {
	if (!phrase) return phrase;
	return phrase
		.toLowerCase()
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
};

export const formatAddress = (address) => {
	let formatted = address;

	const parts = address.split(" ");

	if (parts.length > 3) {
		const stateIndex = address.indexOf(` ${parts[parts.length - 2]} `);

		formatted =
			capitalize(address.substring(0, stateIndex)) +
			address.slice(stateIndex).toUpperCase();
	}

	return formatted;
};

export default { formatAddress, capitalize };
